import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Tooltip } from '@mui/material'
import DriveEta from '@mui/icons-material/DriveEta'
import EuroSymbol from '@mui/icons-material/EuroSymbol'
import LocalOffer from '@mui/icons-material/LocalOffer'
import VpnKey from '@mui/icons-material/VpnKey'
import { VehicleAssignedAs } from '@cbgms/api'
import { StackedIcon } from '@carsys/ui'

export const VehicleType: React.FC<{ type: string; isIndicator?: boolean; iconColor?: string }> = ({ type, isIndicator, iconColor }) => {
  const { t } = useTranslation()

  let title = ''
  switch (type) {
    case VehicleAssignedAs.VehicleSale:
      title = t('VehiclePlateType.sales')
      break
    case VehicleAssignedAs.Rental:
      title = t('VehiclePlateType.rental')
      break
    case VehicleAssignedAs.Courtesy:
      title = t('VehiclePlateType.courtesy')
  }

  return (
    <Tooltip title={title} placement='bottom'>
      <Grid
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pl: 0.5,
          color: iconColor || (isIndicator ? '#21BA45' : 'rgba(0, 0, 0, 0.6)')
        }}
      >
        {type === VehicleAssignedAs.VehicleSale && <StackedIcon SecondaryIcon={<EuroSymbol />} MainIcon={<DriveEta />} />}
        {type === VehicleAssignedAs.Rental && <StackedIcon SecondaryIcon={<VpnKey />} MainIcon={<DriveEta />} />}
        {type === VehicleAssignedAs.Courtesy && <StackedIcon SecondaryIcon={<LocalOffer />} MainIcon={<DriveEta />} />}
      </Grid>
    </Tooltip>
  )
}
